import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import useBackButtonClose from '../utils/useBackButtonClose';

// Renders a thumbnail row + a lightbox on click.
// Props:
//   images: string[] (S3 image URLs, already validated server-side)
//   alt:    string (used for all slides — falls back to "첨부 이미지")
export default function PostGallery({ images, alt }) {
  const [openIndex, setOpenIndex] = useState(-1);

  // 모바일 뒤로가기로 라이트박스만 닫기(SPA 이탈 방지).
  useBackButtonClose(openIndex >= 0, () => setOpenIndex(-1));

  if (!Array.isArray(images) || images.length === 0) return null;

  const slides = images.map(src => ({ src, alt: alt || '첨부 이미지' }));

  return (
    <>
      <div style={{
        display: 'grid',
        // Auto-fit responsive thumbs: minimum 100px on phones (3 fit at 320px),
        // up to 160px on tablets/desktop. Avoids fixed 160px clipping the 3rd
        // photo on narrow screens.
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(160px, calc(33.33% - 6px)), 1fr))',
        gap: 8, margin: '16px 0',
      }}>
        {images.map((url, i) => (
          <button
            key={url}
            type="button"
            onClick={() => setOpenIndex(i)}
            style={{
              padding: 0,
              border: '1px solid #d0d7de',
              borderRadius: 8,
              background: '#fff',
              cursor: 'pointer',
              overflow: 'hidden',
              aspectRatio: '1 / 1',
            }}
            aria-label={`사진 ${i + 1} 크게 보기`}
          >
            <img
              src={url}
              alt={alt || `첨부 이미지 ${i + 1}`}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              // The first image of a review gets eager+high priority for LCP;
              // others lazy. This matters most on the post detail page.
              loading={i === 0 ? 'eager' : 'lazy'}
              fetchpriority={i === 0 ? 'high' : 'auto'}
              decoding="async"
            />
          </button>
        ))}
      </div>
      <Lightbox
        open={openIndex >= 0}
        index={openIndex}
        close={() => setOpenIndex(-1)}
        slides={slides}
        plugins={[Zoom]}
        zoom={{ maxZoomPixelRatio: 3, scrollToZoom: true }}
      />
    </>
  );
}
